import { Routes, Route, Navigate } from 'react-router-dom'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'

import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import Documents from './pages/Documents'
import TeamsTranscripts from './pages/TeamsTranscripts'
import Chat from './pages/Chat'
import Analysis from './pages/Analysis'
import Outputs from './pages/Outputs'
import Smartsheets from './pages/Smartsheets'
import PostImportTasks from './pages/PostImportTasks'
import { GeekModeProvider } from './contexts/GeekModeContext'
import GeekModePanel from './components/GeekModePanel'

function App() {
  const isAuthenticated = useIsAuthenticated()
  const { inProgress } = useMsal()

  // Show loading while MSAL is processing
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-dark">
        <div className="text-center">
          <div className="spinner w-12 h-12 mx-auto"></div>
          <p className="mt-4 text-slate-400">Loading...</p>
        </div>
      </div>
    )
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <Login />
  }

  // Authenticated routes
  return (
    <GeekModeProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:projectId" element={<ProjectDetail />} />
          <Route path="/projects/:projectId/documents" element={<Documents />} />
          <Route path="/projects/:projectId/teams" element={<TeamsTranscripts />} />
          <Route path="/projects/:projectId/chat" element={<Chat />} />
          <Route path="/projects/:projectId/analysis" element={<Analysis />} />
          <Route path="/projects/:projectId/outputs" element={<Outputs />} />
          <Route path="/projects/:projectId/smartsheets" element={<Smartsheets />} />
          <Route path="/projects/:projectId/post-import" element={<PostImportTasks />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
      <GeekModePanel />
    </GeekModeProvider>
  )
}

export default App
